import React, { useEffect } from 'react';
import { AppContext, DynamicComponent } from '@thd-nucleus/app-render';
import { declareContexts } from '@thd-olt-component-react/hydrator';
import { shape, bool } from 'prop-types';
import { Col, Row, Placeholder } from '@thd-olt-component-react/core-ui';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

import { hybridLayoutDataModel } from '../utils/DataModel';

const HybridContentfulWidgets = ({
  contentElements,
  loading
}) => {
  declareContexts([AppContext]);
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('hybrid.ready');
  }, []);
  return (
    <div>
      {contentElements
        && !loading
        && (
          <div data-component="hybrid-upper-components">
            <Row data-testid="hero-carousel">
              <ErrorBoundary name="contentful-hero-carousel">
                <Col lg="12">
                  <contentElements.HeroCarousel />
                </Col>
              </ErrorBoundary>
            </Row>
            <div data-testid="dynamic-section">
              {contentElements.dynamicSections?.map((SubSection, key) => (
                <ErrorBoundary key={key} name={`dynamicSection-${key}`}>
                  <div>
                    <DynamicComponent
                      bypassFeatureSwitch
                      pageType="hybridLayout"
                      placeholder={(
                        <Placeholder
                          width="100%"
                          height="200px"
                        />
                      )}
                    >
                      <Row>
                        <ErrorBoundary name={`dynamicSection-${key}`}>
                          <Col lg="12">
                            <SubSection />
                          </Col>
                        </ErrorBoundary>
                      </Row>

                    </DynamicComponent>
                  </div>
                </ErrorBoundary>
              ))}
            </div>
          </div>
        )}
    </div>
  );
};
HybridContentfulWidgets.propTypes = {
  contentElements: shape({}).isRequired,
  loading: bool,
};

HybridContentfulWidgets.defaultProps = {
  loading: false
};

HybridContentfulWidgets.displayName = 'HybridContentfulWidgets';

HybridContentfulWidgets.dataModel = hybridLayoutDataModel;

export { HybridContentfulWidgets };
